import { createStore } from 'redux';

const totalReducer =
    (
        state = {
            total: 0,
            totalInvestido: 0,
            totalFixas: 0,
            totalInvestidoFixas: 0,
            totalAcoes: 0,
            totalInvestidoAcoes: 0,
            totalFIIs: 0,
            totalInvestidoFIIs: 0,
            totalStocks: 0,
            totalInvestidoStocks: 0,
            totalETFs: 0,
            totalInvestidoETFs: 0,
            totalREITs: 0,
            totalInvestidoREITs: 0
        },
        action
    ) => {
        if (action.type === 'reset') {
            return {
                ...state,
                total: 0,
                totalInvestido: 0
            };
        }
        if (action.type === 'sum') {
            const sum = action.value.reduce((acc, num) => acc + num, 0);
            return {
                ...state,
                total: sum
            };
        }

        if (action.type === 'setTotalFixas') {
            return {
                ...state,
                totalFixas: action.value
            };
        }

        if(action.type === 'setTotalInvestidoFixas'){
            return {
                ...state,
                totalInvestidoFixas: action.value
            };            
        }

        if (action.type === 'setTotalAcoes') {
            return {
                ...state,
                totalAcoes: action.value
            };
        }

        if (action.type === 'setTotalInvestidoAcoes') {
            return {
                ...state,
                totalInvestidoAcoes: action.value
            };
        }        

        if (action.type === 'setTotalFIIs') {
            return {
                ...state,
                totalFIIs: action.value
            };
        }

        if (action.type === 'setTotalInvestidoFIIs') {
            return {
                ...state,
                totalInvestidoFIIs: action.value
            };
        }

        if (action.type === 'setTotalStocks') {
            return {
                ...state,
                totalStocks: action.value
            };
        }
        if (action.type === 'setTotalInvestidoStocks') {
            return {
                ...state,
                totalInvestidoStocks: action.value
            };
        }

        if (action.type === 'setTotalETFs') {
            return {
                ...state,
                totalETFs: action.value
            };
        }
        if (action.type === 'setTotalInvestidoETFs') {
            return {
                ...state,
                totalInvestidoETFs: action.value
            };
        }        

        if (action.type === 'setTotalREITs') {
            return {
                ...state,
                totalREITs: action.value
            };
        }
        if (action.type === 'setTotalInvestidoREITs') {
            return {
                ...state,
                totalInvestidoREITs: action.value
            };
        }        
        return state;
    };

const store = createStore(totalReducer);

export default store;